var __assign = Object.assign;
import Vue from "vue";
export const createSpin = (component) => {
  component.open = function(data = {}) {
    const VueComponent = Vue.extend(component);
    let spinVm = new VueComponent({
      propsData: __assign(__assign({}, data), {
        loading: true
      })
    });
    spinVm.appendToBody = true;
    this.close = () => {
      spinVm.appendToBody = false;
    };
    spinVm.$mount();
  };
  return component;
};
